import { ProductEvaluateStatusEnum } from "./enums/ProductEvaluateStatusEnum"

export class ProductsForTaskDetails {
  productCount: number
  checkFormName: string
  data: ListData[]
}

export interface ListData {
  id: number
  productName: string
  totalScore: number
  productImage: any
  isEvaluated: boolean
  canStartEvaluation: boolean
  canUpdate: boolean
  canviewProductEvaluationResult: boolean
  evaluateStatus: ProductEvaluateStatusEnum
}
